import { Helmet } from 'react-helmet-async';
import { Phone } from 'react-feather';
import FeaturesBottom from './FeaturesBottom';

function AboutUs() {
    return (
        <>
            <Helmet>
                <title>About Us - Kadhr</title>
                <meta 
                    name="description" 
                    content="Discover Kadhr — an AI-powered business OS that helps you turn one-time buyers into repeat customers automatically." 
                />
            </Helmet>
            <main className="mtopcon0 ovrflwhdn" id="up">
                <a href="https://wa.me/254794072134" target="_blank" rel="noopener noreferrer" className="wappcomms btn-hover float-left">
                    <Phone className="text-white" />
                </a>

                <div className="row">
                    <div className="col-12 text-center text-white pt-6indx">
                        <h1 className="mb-3 display-6 font-bold">
                            <b>
                                <span className="text-primary">We're</span> <span className="text-dark">Kadhr.</span>
                            </b>
                        </h1>
                        <p className="mb-4 font1 text-grey">
                            Business automation made simple, smart, and conversational ✨
                        </p>
                    </div>

                    <div className="col-12 pt-6indx0">
                        <div className="container containerwide">
                            <div className="row justify-content-center">
                                <div className="col-md-8">

                                    <h4><b>Our Mission</b></h4>
                                    <p className="mb-5">
                                        We’re on a mission to help businesses turn one-time buyers into repeat customers.
                                    </p>

                                    <h4><b>Why We Exist</b></h4>
                                    <p className="mb-5">
                                        <b>Kadhr</b> comes from the Swahili word <i>“Kadhaa”</i> — meaning several times.
                                        <br /><br />
                                        Businesses grow when customers return again and again.

                                        Kadhr helps you stay connected with customers so they remember you when it's time to buy again.
                                        <br /><br />
                                        Across Africa, entrepreneurs rely on WhatsApp, Instagram, and manual systems to run their businesses. 
                                        Sales happen, but customers are rarely followed up — and many never return.
                                        <br /><br />
                                        Kadhr was built to fix that. By connecting sales, payments, and customer data in one place, 
                                        Kadhr helps businesses remember their customers, understand what they love, and reconnect with them at the right time.
                                        <br /><br />
                                        No guesswork. No generic messaging. Just smarter relationships — and consistent growth.
                                    </p>

                                    <h4><b>Who We Build For</b></h4>
                                    <p>
                                        Kadhr is designed for businesses that rely on repeat customers to grow.
                                    </p>
                                    <ul className="mb-5">
                                        <li>- You run your business solo or with a small, focused team</li>
                                        <li>- You sell products customers buy regularly (cosmetics, perfume, pharmacy, etc.)</li>
                                        <li>- You want customers to come back — without manually chasing them</li>
                                    </ul>

                                    <h4><b>The Big Picture</b></h4>
                                    <p className="mb-5">
                                        We believe businesses grow when customers return — again and again.
                                        <br /><br />
                                        Kadhr is building the infrastructure for relationship-driven commerce in emerging markets — 
                                        where every transaction becomes part of a long-term customer relationship.
                                        <br /><br />
                                        Not just selling once — but building businesses customers come back to, several times.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <FeaturesBottom/>
                </div>
            </main>
        </>
    );
}

export default AboutUs;
